import { Accordion } from 'ui/components';

export const AccordionFeature: React.FC<Content.Accordion> = ({
    content,
    settings,
}) => {
    const { accordionItems } = content?.properties ?? {};
    const { showOpenCloseAll } = settings?.properties ?? {};

    return (
        <Accordion
            {...content?.properties}
            showOpenCloseAll={showOpenCloseAll}
            accordionItems={accordionItems.map(({ content, settings }) => {
                const { htmlContent, title, anchor } =
                    content?.properties ?? {};
                const { openByDefault } =
                    settings?.properties ?? {};

                return {
                    htmlContent,
                    title,
                    anchor,
                    openByDefault,
                };
            })}
        />
    );
};